import apiBase from 'src/api/api-base';
import { endpoints } from 'src/config/endpoints';
import User from 'src/models/user';

export const getAllUsers = async (): Promise<User[]> =>
  new Promise((resolve, reject) => {
    apiBase.get(endpoints.users.getAll).then((response) => {
      resolve(response.data as User[]);
    });
  });
export const getUser = async (id: number | string): Promise<User> =>
  new Promise((resolve, reject) => {
    apiBase.get(endpoints.users.getUser(id)).then((response) => {
      resolve(response.data as User);
    });
  });
export const createUser = async (user: User): Promise<User> =>
  new Promise((resolve, reject) => {
    apiBase.post(endpoints.users.addUser, user).then((response) => {
      resolve(response.data as User);
    });
  });
export const updateUser = async (user: User): Promise<User> =>
  new Promise((resolve, reject) => {
    apiBase.put(endpoints.users.updateUser(user.id), user).then((response) => {
      resolve(response.data as User);
    });
  });
export const deleteUser = async (id: number | string): Promise<User> =>
  new Promise((resolve, reject) => {
    apiBase.delete(endpoints.users.deleteUser(id)).then((response) => {
      resolve(response.data as User);
    });
  });
